import { t } from "i18next";
import { toast } from "react-hot-toast";
import Axios from "../../axios";
import { DateTime } from "luxon";
const getStudyAlerts = (isManualUpdate = false, setStudyAlerts) => {
    const fetchStudyAlerts = async () => {
        let loadingToastId;
        if (isManualUpdate) {
            loadingToastId = toast.loading(t("common:loading"));
        }
        try {
            const studies = JSON.parse(localStorage?.studies || "[]");
            let studyAlerts = {};
            for (const study of studies) {
                try {
                    const response = await Axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}studies/${study?.uuid}/alerts/`,
                    );
                    studyAlerts[study?.uuid] = response?.data;
                } catch (err) {
                    console.error(
                        `Error fetching alerts for ${study?.uuid} _ ${study?.name}: `,
                        err,
                    );
                }
            }
            localStorage.setItem("studyAlerts", JSON.stringify(studyAlerts));
            setStudyAlerts(studyAlerts);
        } catch (error) {
            console.error("Error fetching study alerts:", error);
            isManualUpdate && toast.error(error?.message);
        } finally {
            console.info(`\u2605 Fetch Study Alerts Fired`);
            isManualUpdate && toast.dismiss(loadingToastId);
            localStorage.setItem(
                "getStudyAlertsTimeStamp",
                DateTime.now().toISO(),
            );
        }
    };
    if (isManualUpdate) {
        fetchStudyAlerts();
    } else {
        const lastFetchTime = localStorage.getItem("getStudyAlertsTimeStamp");
        const now = DateTime.now();
        if (
            !lastFetchTime ||
            now.diff(DateTime.fromISO(lastFetchTime), "minutes").minutes > 59
        ) {
            fetchStudyAlerts();
        }
    }
};

export default getStudyAlerts;
